<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1400px"
      title="采购订单"
      id-key="commentId"
      form-label-width="110px"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="()=>{}"
      @details-opened="onDetailsDialog"
      :close-on-saved="true"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <div class="border">
            <el-row>
              <el-col :span="6">
                <el-form-item label="单据编号" prop="DocNo">
                  <span>{{ data.DocNo }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="单据日期" prop="DocDate">
                  <span>{{$commonJs.toDateString(data.DocDate)}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商" prop="SupplierName">
                  <span>{{data.SupplierName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="预计到货日期">
                  <span>{{$commonJs.toDateString(data.DeliveryDate)}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="业务员" prop="ClerkName">
                  <span>{{data.ClerkName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注" prop="Remark">
                  <span>{{data.Remark}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <dialog-list
            ref="dialogList"
            :disposeTax="DisposeTax"
            :info="data"
            readonly
            @getList="getList"
          />
          <el-col :span="6">
            <el-form-item label="无税金额" prop="NoTaxAmount">
              <span>{{ $commonJs.toThousands(data.NoTaxAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税额" prop="TaxAmount">
              <span>{{ $commonJs.toThousands(data.TaxAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单金额" prop="Amount">
              <span>{{ $commonJs.toThousands(data.Amount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="付款金额" prop="PayAmount">
              <span>{{ $commonJs.toThousands(data.PayAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="剩余金额" prop="RemainAmount">
              <span>{{ $commonJs.toThousands(data.RemainAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-row>
            <el-row>
              <el-col :span="24">
                <el-divider />
                <span style="margin-left: 16px; line-height: 50px">付款信息</span>
              </el-col>
            </el-row>
            <el-row v-for="(item, index) in data.Pays" :key="index">
              <el-col :span="6">
                <el-form-item label="结算方式" prop="SettleId">{{item.SettleName}}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="付款账号" prop="AccountId">{{item.Bank+item.AccountName}}</el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="付款金额" prop="PayAmount">{{item.PayAmount}}</el-form-item>
              </el-col>
              <el-col :span="1"></el-col>
            </el-row>
          </el-row>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="danger" @click="cancelExamine" v-if="data.Status==2&&canExa">弃 审</el-button>
        <el-button type="success" @click="examine" v-else-if="canExa">通 过</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dialogList from "./dialogList";
export default {
  props: {
    DisposeTax: {
      type: [String, Number],
      default: "",
    },
  },
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
  },
  data() {
    return {
      data: {
        SupplierId: null,
        SupplierName: "",
        OrderId: 0,
        CustomerId: null,
        CustomerName: "",
        CustomerType: null,
        DocNo: "",
        DocDate: "",
        Status: 0,
        Source: 0,
        Remark: "",
        CouponCustomerId: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        PayAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        ClerkName: "",
        ClerkId: 0,
        //----
        DeliveryDate: "",
        // DisposeTax:null,
        Goods: [],
        Pays: [],
      },
      canExa: false, 
      tableData: [],
      // PriAdjustEmpList: [],
      api: require("@/api/purchase/order").default,    

      rules: { 
      },
    };
  },
  methods: {
    getList(list) {
      this.tableData = list;
      let Amount = null;
      let TaxAmount = null;
      let PayAmount = this.data.PayAmount || 0;
      list.forEach((item) => {
        if (item.T != 2) {
          Amount += Number(item.Amount);
          TaxAmount += Number(item.TaxAmount);
        }
      });
      this.data.Amount = Amount;
      this.data.TaxAmount = TaxAmount;
      this.data.NoTaxAmount = Amount - TaxAmount;
      this.data.RemainAmount = Amount - PayAmount;
    },
    examine() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.examine(this.data.OrderId).then((res) => {
          if (res.Code == 0) {
            this.$message.success("审核成功");
            this.readonly = true;
            this.close();
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    cancelExamine() {
      this.$confirm("确认弃审吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.cancelExamine(this.data.OrderId).then((res) => {
          if (res.Code == 0) {
            this.$message.success("弃审成功");
            this.readonly = false;
            this.close();
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onDetailsDialog() {
      this.canExa = true;

      this.$refs.dialogList.getData();
    },
  },
};
</script>
<style lang="scss">
.is-disabled {
  input,
  textarea {
    background-color: #fff !important;
    color: #333 !important;
  }
}
.border {
  padding: 15px 25px 0 0;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>